// extracted by mini-css-extract-plugin
export default {"root":"ListingSize_root__LTOII h5"};